import React, { useState } from 'react';
import { openExternalURL } from '~/helpers';
import {
  Container,
  MapThumbnail,
  LocationInfo,
  Label,
  Address,
  PinDot,
} from './styles';

interface LocationPreviewProps {
  label: string;
  address: string;
  latitude: string;
  longitude: string;
}

const TILE_ZOOM = 15;

function buildTileUrl(lat: string, lon: string): string {
  const latNum = parseFloat(lat);
  const lonNum = parseFloat(lon);
  const x = Math.floor(((lonNum + 180) / 360) * 2 ** TILE_ZOOM);
  const y = Math.floor(
    ((1 -
      Math.log(
        Math.tan((latNum * Math.PI) / 180) +
          1 / Math.cos((latNum * Math.PI) / 180)
      ) /
        Math.PI) /
      2) *
      2 ** TILE_ZOOM
  );
  return `https://tile.openstreetmap.org/${TILE_ZOOM}/${x}/${y}.png`;
}

const PinIcon: React.FC = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
  </svg>
);

const LocationPreview: React.FC<LocationPreviewProps> = ({
  label,
  address,
  latitude,
  longitude,
}) => {
  const [imgError, setImgError] = useState(false);

  const tileUrl = buildTileUrl(latitude, longitude);

  const handleClick = () => {
    openExternalURL(`https://www.google.com/maps?q=${latitude},${longitude}`);
  };

  return (
    <Container onClick={handleClick} title="Open in Google Maps">
      <MapThumbnail>
        {!imgError ? (
          <img src={tileUrl} alt="Map" onError={() => setImgError(true)} />
        ) : (
          <div className="map-fallback">
            <PinIcon />
            <PinDot />
          </div>
        )}
      </MapThumbnail>
      <LocationInfo>
        {label ? <Label title={label}>{label}</Label> : null}
        {address ? <Address title={address}>{address}</Address> : null}
      </LocationInfo>
    </Container>
  );
};

export default LocationPreview;
